import React, { useState } from 'react';

function MobileReviewDeck({ reviews }) {
  const [active, setActive] = useState(0);

  const next = () => setActive(prev => (prev + 1) % reviews.length);
  const prev = () => setActive(prev => (prev - 1 + reviews.length) % reviews.length);

  return (
    <div className="mobile-review-deck">
      {/* Card stack — show all 3, active one on top */}
      <div className="deck-stack">
        {reviews.map((review, idx) => {
          const offset = (idx - active + reviews.length) % reviews.length;
          return (
            <div
              key={review.id}
              className="deck-card"
              style={{
                transform: offset === 0
                  ? 'translateY(0px) scale(1)'
                  : offset === 1
                  ? 'translateY(16px) scale(0.95)'
                  : 'translateY(28px) scale(0.90)',
                zIndex: reviews.length - offset,
                opacity: offset === 2 ? 0.5 : 1,
                transition: 'all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
              }}
            >
              {/* Quote mark */}
              <div className="deck-quote-mark">"</div>

              <p className="deck-review-text">"{review.text}"</p>

              <div className="deck-reviewer">
                <div className="deck-avatar">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="1.5">
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
                <div>
                  <div className="deck-name">{review.name}</div>
                  <div className="deck-role">{review.role}</div>
                </div>
                <div className="deck-stars">{"★".repeat(review.stars)}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Controls */}
      <div className="deck-controls">
        <button className="deck-btn" onClick={prev}>←</button>
        <div className="deck-dots">
          {reviews.map((_, i) => (
            <div
              key={i}
              className={`deck-dot ${i === active ? 'active' : ''}`}
              onClick={() => setActive(i)}
            />
          ))}
        </div>
        <button className="deck-btn" onClick={next}>→</button>
      </div>

      {/* Counter */}
      <div className="deck-counter">{active + 1} / {reviews.length}</div>
    </div>
  );
}

export default MobileReviewDeck;